import axios from '@/api/axios'

export default {
    getAllForSelected: (id) =>
        axios.get(`/base/api/payments/${id}`).then((res) => res.data),
    addNewPayment: (data) =>
        axios.post('/base/api/payment', { ...data }).then((res) => res.data),
    getPaymentTypes: () =>
        axios
            .get(`/base/api/accounting/payment-types`)
            .then((res) => res.data.data),
    getPaymentBanks: () =>
        axios
            .get(`/base/api/accounting/payment-banks`)
            .then((res) => res.data.data),
}
